'use strict';

var app = require('angular').module('app');

app.config(require('./translate'));
app.config(require('./routes'));
app.config(['$qProvider', function($qProvider) {
	$qProvider.errorOnUnhandledRejections(false);
}]);
app.config(require('./html5mode'));
app.config(function($httpProvider){
    delete $httpProvider.defaults.headers.common['X-Requested-With'];
});
